var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveServicingReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_258_60804",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_258_60804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.0769C9.58444 18.0769 9.22951 17.9297 8.93521 17.6354C8.64076 17.3411 8.49354 16.9861 8.49354 16.5704H11.5065C11.5065 16.9861 11.3592 17.3411 11.0648 17.6354C10.7705 17.9297 10.4156 18.0769 10 18.0769ZM3.75 15.7371V14.4873H5.25646V8.26917C5.25646 7.17736 5.58313 6.20674 6.23646 5.35729C6.88979 4.50799 7.73889 3.94875 8.78375 3.67958C8.65222 4.00861 8.55153 4.3518 8.48167 4.70917C8.41167 5.06653 8.37667 5.42521 8.37667 5.78521C8.37667 6.64521 8.54917 7.435 8.89417 8.15458C9.23931 8.87417 9.70833 9.48715 10.3012 9.99354C10.8942 10.4999 11.5713 10.8736 12.3325 11.1146C13.0938 11.3554 13.8974 11.416 14.7435 11.2965V14.4873H16.25V15.7371H3.75ZM13.3013 9.48708L13.1315 8.49354C12.9167 8.42951 12.7151 8.34861 12.5265 8.25083C12.3378 8.15305 12.1592 8.02458 11.9904 7.86542L11.0385 8.19229L10.3975 7.14417L11.1635 6.48729C11.1037 6.25326 11.0737 6.01923 11.0737 5.78521C11.0737 5.55132 11.1037 5.31736 11.1635 5.08333L10.3975 4.42625L11.0385 3.37833L11.9904 3.70521C12.1539 3.54604 12.3313 3.41757 12.5225 3.31979C12.7138 3.22201 12.9167 3.14104 13.1315 3.07687L13.3013 2.08333H14.5513L14.721 3.07687C14.9359 3.14104 15.1389 3.22201 15.33 3.31979C15.5213 3.41757 15.6986 3.54604 15.8621 3.70521L16.814 3.37833L17.455 4.42625L16.689 5.08333C16.7488 5.31736 16.7788 5.55132 16.7788 5.78521C16.7788 6.01923 16.7488 6.25326 16.689 6.48729L17.455 7.14417L16.814 8.19229L15.8621 7.86542C15.6933 8.02458 15.5147 8.15305 15.326 8.25083C15.1376 8.34861 14.9359 8.42951 14.721 8.49354L14.5513 9.48708H13.3013ZM13.9263 7.51604C14.406 7.51604 14.8144 7.3475 15.1515 7.01042C15.4885 6.67333 15.6571 6.26493 15.6571 5.78521C15.6571 5.30548 15.4885 4.89708 15.1515 4.56C14.8144 4.22292 14.406 4.05437 13.9263 4.05437C13.4465 4.05437 13.0381 4.22292 12.701 4.56C12.364 4.89708 12.1954 5.30548 12.1954 5.78521C12.1954 6.26493 12.364 6.67333 12.701 7.01042C13.0381 7.3475 13.4465 7.51604 13.9263 7.51604Z",
    fill: "#155DFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveServicingReminder);
export default __webpack_public_path__ + "static/media/Active Servicing & Reminder.52e2251970ccc042c750950fc2db28a0.svg";
export { ForwardRef as ReactComponent };